<h2 mat-dialog-title>Confirmation</h2>

<mat-dialog-content>
  <p>{{ data.question }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="warn" (click)="onCancel()">
    {{ data.cancelText || "No" }}
  </button>
  <button mat-flat-button color="primary" (click)="onConfirm()">
    {{ data.confirmText || "Yes" }}
  </button>
</mat-dialog-actions>
